export const initialState = {
  registration: null
};
